import { branchStateToChipTypeMap } from 'views/root/views/home/views/activity/views/branchesV2/branches.service';
import { StyledCell } from '../../Table.style';
import Chip from 'components/base/Chip';

const StateCell = ({ state }) => {
  return (
    <StyledCell>
      <Chip
        label={state}
        size='auto'
        variant='outlined'
        color={branchStateToChipTypeMap[state]}
      />
    </StyledCell>
  );
};

export default StateCell;
